import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";
import { ReactNode } from "react";

const TIMELINE_CIRCLE_SIZE = 32;
const TIMELINE_CONNECTOR_WIDTH = 2;
const CIRCLE_RADIUS = TIMELINE_CIRCLE_SIZE / 2;

const TIMELINE_COLUMN_STYLE = { flex: "0 0 auto", width: TIMELINE_CIRCLE_SIZE } as const;

const TIMELINE_CONNECTOR_STYLE = {
  width: 0,
  flex: "1 1 auto",
  minHeight: 20,
  borderLeftWidth: TIMELINE_CONNECTOR_WIDTH,
  borderLeftStyle: "dashed",
} as const;

const MIN_WIDTH_STYLE = { minWidth: 0 } as const;

export const CELL_LABEL_HEIGHT = 20;
export const CELL_VALUE_HEIGHT = 30;

interface IRoundedLoader {
  width: number | string;
  height: number;
  radius: number;
  className?: string;
}

export function RoundedLoader({ width, height, radius, className = "display-block" }: Readonly<IRoundedLoader>) {
  return (
    <ContentLoader className={className} width={width} height={height}>
      <rect width="100%" height="100%" rx={radius} ry={radius} />
    </ContentLoader>
  );
}

export interface ITimelineSkeletonCell {
  key: string;
  labelWidth: number;
}

interface ITimelineSkeletonRow {
  isLast: boolean;
  cells: readonly ITimelineSkeletonCell[];
  renderCell: (cell: ITimelineSkeletonCell, cellIndex: number) => ReactNode;
}

export function TimelineSkeletonRow({ isLast, cells, renderCell }: Readonly<ITimelineSkeletonRow>) {
  return (
    <div className="display-flex align-items-start gap-15">
      <div className="display-flex flex-column align-items-center align-self-stretch" style={TIMELINE_COLUMN_STYLE}>
        <ContentLoader
          className="display-block"
          height={TIMELINE_CIRCLE_SIZE}
          width={TIMELINE_CIRCLE_SIZE}
          rx={CIRCLE_RADIUS}
          ry={CIRCLE_RADIUS}
        />
        {!isLast && <div className="border-color-lighter" style={TIMELINE_CONNECTOR_STYLE} />}
      </div>

      <div
        className={`flex-1-1 border border-color-light rounded-small display-flex flex-wrap ${
          isLast ? "" : "margin-bottom-15"
        }`}
        style={MIN_WIDTH_STYLE}
      >
        {cells.map((cell, cellIndex) => (
          <div
            key={cell.key}
            className={`flex-1-1 padding-10 width-100pct-xs ${
              cellIndex === 0 ? "" : "border border-left-only border-color-light"
            }`}
            style={MIN_WIDTH_STYLE}
          >
            {renderCell(cell, cellIndex)}
          </div>
        ))}
      </div>
    </div>
  );
}
